// const enUsTranslationResource = {
//   hello: 'hello, world',
// }

// export default enUsTranslationResource

export default {
  name: 'my name is fan zhongkui'
}


// WEBPACK FOOTER //
// ./src/international/en.js